var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { Dependencies, Layout, Auth } from "~/core/decorator";
import { Getter, namespace, State } from "vuex-class";
import { PageService } from "~/utils/page.service";
import { SortService } from "~/utils/sort.service";
import NumberRange from "~/components/common/number-range.vue";
import { TelCaseManageService } from "~/services/domain-service/tel-case-manage.service";
import CaseAllot from "~/components/distribution-common/case-allot.vue";
import { ApplyType, CASE_CHANNEL, MENU_CHANNEL } from "~/config/enum.config";
import GetLabelName from "~/components/labeling-strategy/get-label-name.vue";
import PauseApply from "~/components/apply-component/pause-apply.vue";
import SelectDepartment from "~/components/business-component/select-department.vue";
import PrincipalRecovery from "~/components/apply-component/principal-recovery.vue";
var AllotModule = namespace("case-allot");
var TelStopCaseManage = /** @class */ (function (_super) {
    __extends(TelStopCaseManage, _super);
    function TelStopCaseManage() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.caseChannel = CASE_CHANNEL.tel;
        _this.model = {
            caseNumber: "",
            personalName: "",
            mobileNo: "",
            idCard: "",
            overdueAmount: {
                max: "",
                min: ""
            },
            loanDate: [],
            principalId: '',
            partCollectionRemainingDays: { min: '', max: '' },
            personalCollectionRemainingDays: { min: '', max: '' },
            bankName: '',
            businessAddress: '',
            boardAddress: '',
            carNo: '',
            dataFromSource: '',
            followInTime: [],
            deptId: '',
            currentCollectorRealName: '',
            pauseTime: [],
            partnerName: '',
            batchNumber: ''
        };
        _this.dialog = {
            ManualDivision: false,
            apply: false,
            principalRecovery: false
        };
        _this.rules = {};
        _this.dataSet = [];
        _this.selectionList = [];
        _this.applyType = ApplyType.active;
        return _this;
    }
    TelStopCaseManage.prototype.created = function () {
        this.refreshData();
    };
    TelStopCaseManage.prototype.refreshData = function () {
        var _this = this;
        this.telCaseManageService
            .pauseCasePool(this.paramsHandler(), this.pageService, this.sortService)
            .subscribe(function (data) {
            _this.dataSet = data;
            _this.selectionList = [];
        });
    };
    TelStopCaseManage.prototype.paramsHandler = function () {
        var params = __assign({}, this.model);
        params.overdueAmountMax = this.model.overdueAmount ? this.model.overdueAmount.max : "";
        params.overdueAmountMin = this.model.overdueAmount ? this.model.overdueAmount.min : "";
        params.partCollectionRemainingDaysMax = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.max : "";
        params.partCollectionRemainingDaysMin = params.partCollectionRemainingDays ? this.model.partCollectionRemainingDays.min : "";
        params.personalCollectionRemainingDaysMax = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.max : "";
        params.personalCollectionRemainingDaysMin = params.personalCollectionRemainingDays ? this.model.personalCollectionRemainingDays.min : "";
        params.followInTimeMin = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[0]) : '';
        params.followInTimeMax = this.model.followInTime.length ? this.$filter.dateTimeFormat(this.model.followInTime[1]) : '';
        params.loanDateMin = this.$filter.dateRanageFormat(this.model.loanDate).start;
        params.loanDateMax = this.$filter.dateRanageFormat(this.model.loanDate).end;
        params.pauseTimeMin = this.model.pauseTime.length ? this.$filter.dateTimeFormat(this.model.pauseTime[0]) : '';
        params.pauseTimeMax = this.model.pauseTime.length ? this.$filter.dateTimeFormat(this.model.pauseTime[1]) : '';
        delete params.overdueAmount;
        delete params.partCollectionRemainingDays;
        delete params.personalCollectionRemainingDays;
        delete params.followInTime;
        delete params.loanDate;
        delete params.pauseTime;
        return params;
    };
    /**
     * 表单范围输入框重置
     */
    TelStopCaseManage.prototype.handleResetForm = function () {
        this.model.overdueAmount = { min: "", max: "" };
        this.model.partCollectionRemainingDays = { min: '', max: '' };
        this.model.personalCollectionDays = { min: '', max: "" };
    };
    /**
     * 重新分案
     */
    TelStopCaseManage.prototype.manualDivision = function () {
        if (this.selectionList.length === 0) {
            this.$message.info("请选择要分配的案件");
            return;
        }
        var currentDate = new Date();
        var findBeforFlag = this.selectionList.some(function (x) { return x.pauseDueTime && x.pauseDueTime > currentDate; });
        if (findBeforFlag) {
            this.$message("您选择的案件中含有未到期案件，不能重新分案");
            return;
        }
        this.updateCaseIds(this.selectionList.map(function (v) { return v.id; }));
        this.dialog.ManualDivision = true;
    };
    TelStopCaseManage.prototype.activeClick = function () {
        if (this.selectionList.length === 0) {
            this.$message("\u8BF7\u9009\u62E9\u8981" + this.applyType.name + "\u7684\u6848\u4EF6");
            return;
        }
        this.dialog.apply = true;
    };
    Object.defineProperty(TelStopCaseManage.prototype, "selectedCaseIds", {
        get: function () {
            return this.selectionList.map(function (v) { return v.id; });
        },
        enumerable: false,
        configurable: true
    });
    TelStopCaseManage.prototype.departemntChange = function (id, code) { };
    /**
     * 进入查看执行页
     */
    TelStopCaseManage.prototype.openExecutionPage = function (row) {
        this.$router.openCaseDetail(row.id, {
            menuChannel: MENU_CHANNEL.Tel_closed,
            hiddenCaseList: true,
            hiddenAction: true
        });
    };
    /**
     * 委托方回收
     */
    TelStopCaseManage.prototype.dealManualPartReturnCase = function () {
        if (this.selectionList.length !== 0) {
            this.dialog.principalRecovery = true;
        }
        else {
            this.$message("\u8BF7\u9009\u62E9\u8981\u8FDB\u884C\u59D4\u6258\u65B9\u56DE\u6536\u7684\u6848\u4EF6");
        }
    };
    __decorate([
        Dependencies(PageService)
    ], TelStopCaseManage.prototype, "pageService", void 0);
    __decorate([
        Dependencies(SortService)
    ], TelStopCaseManage.prototype, "sortService", void 0);
    __decorate([
        Dependencies(TelCaseManageService)
    ], TelStopCaseManage.prototype, "telCaseManageService", void 0);
    __decorate([
        Getter
    ], TelStopCaseManage.prototype, "callDepartmentData", void 0);
    __decorate([
        AllotModule.Mutation
    ], TelStopCaseManage.prototype, "updateCaseIds", void 0);
    __decorate([
        State
    ], TelStopCaseManage.prototype, "principalList", void 0);
    TelStopCaseManage = __decorate([
        Auth(207),
        Layout("workspace"),
        Component({
            components: {
                NumberRange: NumberRange,
                CaseAllot: CaseAllot,
                GetLabelName: GetLabelName,
                PauseApply: PauseApply,
                SelectDepartment: SelectDepartment,
                PrincipalRecovery: PrincipalRecovery
            }
        })
    ], TelStopCaseManage);
    return TelStopCaseManage;
}(Vue));
export default TelStopCaseManage;
